import { plainToInstance } from 'class-transformer';
import { apiService } from './api';
import { Customer } from '../dto';

export async function getCustomerInfo(): Promise<Customer> {
  try {
    const path = '/customer/info';
    const res = await apiService({
      method: 'get',
      path,
    });
    const { data, success } = res?.data;

    if (data && success) {
      return plainToInstance(Customer, data as Customer);
    } else {
      throw new Error('Error getting customer info');
    }
  } catch (err) {
    throw err;
  }
};
